var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.viewModel,"type":"number","inputmode":"numeric","label":_vm.label,"hint":_vm.hint,"rules":_vm.rules,"min":0,"validate-on-blur":"","disabled":_vm.disabled},on:{"blur":_vm.handleBlur,"keypress":_vm.handleKeyPress}})
}
var staticRenderFns = []

export { render, staticRenderFns }